export default {
  title: 'Sopimus',
  description: 'Sinulta veloitetaan {{amount}} kuukaudessa, jos et peruuta kokeilujaksoasi.',
  bill_at_launch_date: 'Ensimmäinen lasku julkaisupäivänä',
  bill_date: 'Laskutuspäivä: {{date}}',
  bill_date_after_launch: 'Ensimmäinen laskutuspäivä: {{days}} päivää julkaisun jälkeen',
  sign_agreement: 'Allekirjoita tilaus- ja ravintolan osallistumissopimus',
  restaurant: 'Ravintola',
  agreement:
    'Hyväksyn <a href="{{terms_url}}" target="_blank" rel="noreferrer noopener">alustan ehdot</a>. Voin peruuttaa tilauksen milloin tahansa ilmoittamalla siitä {{provider}}:lle. Tilaus peruutetaan ja maksusopimus kumotaan heti, kun ravintola on yhteydessä {{provider}}:iin peruutuksesta sähköpostitse tai WhatsAppin kautta. Ravintolalta ei veloiteta sen jälkeen enää mitään. Hyväksyn, että sähköinen suostumukseni vastaa tämän asiakirjan allekirjoittamista ja ymmärrän, että sähköinen allekirjoitukseni on sitova.',
};
